(function(){
  if(window.__pfUgcPos)return;window.__pfUgcPos=1;
  function norm(s){return (s||'').toLowerCase();}
  function findAnchor(){
    var e=document.querySelectorAll('h1,h2,h3,h4,p,div,span,strong');
    for(var i=0;i<e.length;i++){
      if(e[i].children.length>3)continue;
      var t=norm(e[i].textContent);
      if(t.indexOf('aimé par')>-1 && t.length<40)return e[i];
    }
    return null;
  }
  function vxEl(){
    var v=document.getElementById('shopify-section-vx_ugc');if(v)return v;
    var u=document.querySelector('.ugc-track');if(u){var s=u.closest('[id^=\"shopify-section\"]');if(s)return s;}
    return null;
  }
  function go(){
    var vx=vxEl();if(!vx)return false;
    if(vx.getAttribute('data-pos'))return true;
    var a=findAnchor();if(!a)return false;
    var block=a;
    for(var k=0;k<10;k++){var p=block.parentElement;if(!p)break;if(p===document.body)break;if(p.id==='shopify-section-vx_ugc')break;if(p.children.length>=5&&block.offsetHeight>120)break;block=p;}
    if(block===vx||vx.contains(block)||block.contains(vx))return false;
    vx.setAttribute('data-pos','1');
    block.parentNode.insertBefore(vx,block);
    return true;
  }
  function boot(){[250,800,1600,2800,4200].forEach(function(ms){setTimeout(function(){try{go();}catch(e){}},ms);});}
  if(document.readyState!=='loading')boot();else document.addEventListener('DOMContentLoaded',boot);
})();